import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';
import { FixedLimitStackRoutes, FixedLimitStackScreenProps } from '@/features/account-management/screens/fixed-limit/type';
import { FixedLimitWebTwoScreen } from '@/features/account-management/screens/fixed-limit/FixedLimitWebTwo.screen';
import { FixedLimitNativeTwoScreen } from '@/features/account-management/screens/fixed-limit/FixedLimitNativeTwo.screen';

export interface NewAccountProps {}
export const FixedLimitPlaced: React.FC<FixedLimitStackScreenProps<FixedLimitStackRoutes.Placed>> = ({ navigation, route }) => {
  const { onLayout, data, returnData, refresh, record } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return <FixedLimitNativeTwoScreen onClose={onGoBack} data={data} returnData={returnData} refresh={refresh} record={record} />;
  }

  return (
    <FixedLimitWebTwoScreen
      onClose={closeModal}
      onLayout={onLayout}
      data={data}
      returnData={returnData}
      refresh={refresh}
      record={record}
    />
  );
};
